/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractResponseDto } from '../../models/sales-contract-response-dto';

export interface ContractsControllerFindByTenant$Params {
  tenant: string;

/**
 * Optional Project Manager id filter. When set, only contracts whose denormalised PM matches are returned.
 */
  projectManagerId?: string;
}

export function contractsControllerFindByTenant(http: HttpClient, rootUrl: string, params: ContractsControllerFindByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContractResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerFindByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesContractResponseDto>>;
    })
  );
}

contractsControllerFindByTenant.PATH = '/o2-sales/contracts/tenant/{tenant}';
